import { FC, useState } from "react";
import Section from "components/gonzo/parts/Section";
import Description from "components/gonzo/parts/Description";
import BreakPc from "components/gonzo/parts/BreakPc";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/gonzo/parts/Headline";
import Content from "components/gonzo/parts/Content";

const Message: FC = () => {
  const [pattern, setPattern] = useState(1);
  const togglePattern = () => setPattern(pattern == 4 ? 1 : pattern + 1);
  return (
    <Section onClick={togglePattern}>
      <AnchorTarget id="message" />
      <Headline src={["/image/lp/gonzo/message/message_title_1.png", "/image/lp/gonzo/message/message_title_2.png"]} alt="ご挨拶" />
      <Content>
        <Description>
          「GONZO」は2022年9月に設立30周年を迎えます。
          <br />
          GONZOは、70作品以上のアニメーション制作を通して、アニメビジネスに携わってまいりました。
          <br />
          ここまで来れたのも全てはアニメを愛してくださっているファンの皆様、
          <br />
          そしてアニメ制作に携わっていただいている関係者の皆々様のおかげです。
          <BreakPc />
          本当にありがとうございます。
          <br />
          <br />
          この度、GONZO設立30周年を記念して、プレゼントキャンペーンや
          <BreakPc />
          クラウドファンディングなど様々な企画を用意しました！
          <br />
          是非楽しんでいただけると幸いです。
          <br />
          <br />
          GONZOは現在もNFT企画「
          <a href="https://samuraicryptos.io/ja" target="_blank" rel="noreferrer">
            SAMURAI cryptos
          </a>
          」をはじめ数々の企画を進行しておりますので、
          <BreakPc />
          引き続き応援をよろしくお願いをいたします。
          <br />
          <br />
          アニメの新作で皆様とお会いできる日を楽しみにしております。
        </Description>
      </Content>
    </Section>
  );
};
export default Message;
